import { ROOT_OBJECT_ATTACHMENT_CONFIG } from '@Hooks/Attachments/rootObjectAttachmentConfig';
import { useAttachmentDownloadUrl } from '@Hooks/Attachments/useAttachmentDownloadUrl';
import { useFileDownload } from '@Hooks/useFileDownload';
import type { ApiPrintAttachmentOption } from '@Model';
import { Button } from '@synqo/frontend-component-library';
import { IconDownload } from '@tabler/icons-react';

interface RawAttachmentDownloadButtonProps {
    attachment: ApiPrintAttachmentOption;
}

/**
 * Download button for a raw, previously uploaded attachment. Uploaded files are never shown in the
 * browser; the button resolves a fresh download URL on click and saves the file.
 */
// @ai-generated 2026-09-28T06:54:35+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5 (1M context)
export function RawAttachmentDownloadButton({ attachment }: RawAttachmentDownloadButtonProps) {
    const config = ROOT_OBJECT_ATTACHMENT_CONFIG[attachment.id];
    const { mutateAsync: resolveDownloadUrl, isPending } = useAttachmentDownloadUrl(
        config?.baseUrl ?? '',
        config?.entityPath ?? '',
        attachment.print_payload.primary_id,
    );
    const { triggerUrlDownload } = useFileDownload();

    if (!config) {
        return null;
    }

    const handleClick = () => {
        void resolveDownloadUrl(attachment.attachment_id)
            .then(triggerUrlDownload)
            .catch(() => undefined);
    };

    return (
        <Button onClick={handleClick} label={attachment.display_name} locked={isPending}>
            <IconDownload size={18} /> {attachment.display_name}
        </Button>
    );
}
